function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useMemo } from 'react';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
import GenericFormElement from '../GenericFormElement';
import SelectInput from '../Select/Input';
import { useExtendedFormikContext } from '../FormikWrapper';
import './style.scss';
function toTwoDigits(value) {
  return ('0' + value).slice(-2);
}
var DateSelect = function DateSelect(props) {
  var title = props.title,
    fieldName = props.fieldName,
    validation = props.validation,
    yearMin = props.yearMin,
    yearMax = props.yearMax,
    minDate = props.minDate,
    maxDate = props.maxDate,
    hideYear = props.hideYear,
    fixedYear = props.fixedYear,
    required = props.required,
    requiredError = props.requiredError,
    notValidError = props.notValidError,
    dayPlaceholder = props.dayPlaceholder,
    monthPlaceholder = props.monthPlaceholder,
    yearPlaceholder = props.yearPlaceholder,
    onChange = props.onChange,
    includeFieldSet = props.includeFieldSet;
  var _useExtendedFormikCon = useExtendedFormikContext(),
    setFieldValue = _useExtendedFormikCon.setFieldValue,
    setFieldError = _useExtendedFormikCon.setFieldError,
    isSubmitting = _useExtendedFormikCon.isSubmitting,
    touched = _useExtendedFormikCon.touched,
    values = _useExtendedFormikCon.values,
    errors = _useExtendedFormikCon.errors,
    displayRequiredIndicator = _useExtendedFormikCon.displayRequiredIndicator;
  var isTouched = touched[fieldName];
  var value = values[fieldName];
  var error = errors[fieldName];
  var errorId = "".concat(props.fieldName, "--error");
  var descriptionId = "".concat(props.fieldName, "--description");
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;

  // Set all states for the date.
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    day = _useState2[0],
    setDay = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    month = _useState4[0],
    setMonth = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    year = _useState6[0],
    setYear = _useState6[1];

  // List all day options
  var dayOptions = useMemo(function (placeholder) {
    var options = [];
    if (placeholder) {
      options.push({
        value: placeholder,
        label: placeholder
      });
    }
    for (var index = 1; index <= 31; index++) {
      options.push({
        value: index,
        label: index
      });
    }
    return options;
  }, []);
  var onChangeHandler = function onChangeHandler(_ref) {
    var changedDay = _ref.changedDay,
      changedMonth = _ref.changedMonth,
      changedYear = _ref.changedYear;
    if (onChange) {
      onChange({
        day: changedDay || day,
        month: changedMonth || month,
        year: changedYear || year
      });
    }
  };

  // List all month options
  var monthOptions = useMemo(function () {
    var months = [t('dateselect.months.jan', 'Januari'), t('dateselect.months.feb', 'Februari'), t('dateselect.months.mar', 'Maart'), t('dateselect.months.apr', 'April'), t('dateselect.months.may', 'Mei'), t('dateselect.months.jun', 'Juni'), t('dateselect.months.jul', 'Juli'), t('dateselect.months.aug', 'Augustus'), t('dateselect.months.sep', 'September'), t('dateselect.months.oct', 'Oktober'), t('dateselect.months.nov', 'November'), t('dateselect.months.dec', 'December')];
    return months.map(function (e, i) {
      return {
        value: i + 1,
        label: e
      };
    });
  }, [t]);

  // List all options for possible years from the yearMin and yearMax variables.
  var yearOptions = useMemo(function () {
    var options = [];
    for (var index = yearMin; index <= yearMax; index++) {
      options.push({
        value: index,
        label: index
      });
    }
    return options;
  }, [yearMin, yearMax]);

  // Validation and setting either an error or the FieldValue
  useEffect(function () {
    if (hideYear) {
      setYear(fixedYear || new Date().getFullYear());
    }

    // In some cases, this element can re-render while there's already a value in the Formik Context.
    // For example, when we build a Webform with multiplate pages, and you go báck a page.
    //
    // The values will still be in the Formik Context, but we need to set them again in useState
    if (value) {
      if (!day && value.getDate()) {
        setDay(value.getDate());
      }
      if (!month && value.getMonth() !== undefined) {
        // months are zero-indexed
        setMonth(value.getMonth() + 1);
      }
      if (!year && value.getFullYear()) {
        setYear(value.getFullYear());
      }
    }

    // All options are filled, start validation
    if (required && (!day || !month || !year)) {
      setFieldError(fieldName, requiredError);
    } else if (day && month && year) {
      // The JavaScript specification only specifies one date format to be universally supported:
      // the date time string format. (See: https://tc39.es/ecma262/multipage/numbers-and-dates.html#sec-date-time-string-format)
      //
      // This means we have to format month and day to a two digits format (we receive them as
      // a single digit), otherwise this will break on some browsers (like Safari).
      var date = new Date("".concat(year, "-").concat(toTwoDigits(month), "-").concat(toTwoDigits(day)));
      setFieldValue(fieldName, date);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmitting, day, month, year]);
  var handleValidation = function handleValidation(value) {
    if (validation && typeof validation === 'function') {
      return validation(value);
    }
    if (required && (!day || !month || !year)) {
      return requiredError || t(['webform.components.date_select.required', 'webform.required', 'webform_required']);
    }
    var date = new Date("".concat(year, "-").concat(toTwoDigits(month), "-").concat(toTwoDigits(day)));
    if (!(
    // Take note of the exclamation mark
    date.getDate() === day && date.getMonth() + 1 === month && date.getFullYear() === year)) {
      // Depending on your browser, an invalid date overflows to the next month.
      // For example, the 30th of Februari can become the 2nd of March.
      // If that is the case, you still get a valid Date object, but it's not what
      // the user filled in.
      return notValidError || t(['webform.components.date_select.invalid', 'webform.invalid', 'webform_invalid']);
    }
    var isoDate = date.toISOString().split('T')[0];
    if (minDate && date.getTime() < new Date(minDate).getTime()) {
      return t(['webform.components.date_select.min', 'webform.min', 'webform_min'], {
        date: isoDate,
        minDate: minDate
      });
    }
    if (maxDate && date.getTime() > new Date(maxDate).getTime()) {
      return t(['webform.components.date_select.max', 'webform.max', 'webform_max'], {
        date: isoDate,
        maxDate: maxDate
      });
    }
  };
  return /*#__PURE__*/React.createElement(GenericFormElement, {
    className: "DateSelect",
    title: title,
    required: required,
    displayRequiredIndicator: displayRequiredIndicator,
    error: error,
    touched: isTouched,
    fieldName: fieldName,
    errorId: errorId,
    descriptionId: descriptionId,
    includeFieldSet: includeFieldSet
  }, /*#__PURE__*/React.createElement(Field, {
    id: fieldName,
    name: fieldName,
    validate: handleValidation,
    value: value
  }, function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectInput, {
      id: "".concat(fieldName, "day"),
      fieldName: "".concat(fieldName, "day"),
      options: dayOptions,
      value: day,
      placeholder: dayPlaceholder,
      onChange: function onChange(day) {
        setDay(day);
        onChangeHandler({
          changedDay: day
        });
      }
    }), /*#__PURE__*/React.createElement(SelectInput, {
      id: "".concat(fieldName, "month"),
      fieldName: "".concat(fieldName, "month"),
      options: monthOptions,
      value: month,
      placeholder: monthPlaceholder,
      onChange: function onChange(month) {
        setMonth(month);
        onChangeHandler({
          changedMonth: month
        });
      }
    }), !hideYear && /*#__PURE__*/React.createElement(SelectInput, {
      id: "".concat(fieldName, "year"),
      fieldName: "".concat(fieldName, "year"),
      options: yearOptions,
      value: year,
      placeholder: yearPlaceholder,
      onChange: function onChange(year) {
        setYear(year);
        onChangeHandler({
          changedYear: year
        });
      }
    }));
  }));
};
DateSelect.defaultProps = {
  title: 'Kies een datum',
  fieldName: 'dateSelect',
  yearMin: 1970,
  yearMax: 2042,
  hideYear: false,
  requiredError: 'Waarde mag niet leeg zijn',
  notValidError: 'Ongeldige datum',
  dayPlaceholder: 'Dag',
  monthPlaceholder: 'Maand',
  yearPlaceholder: 'Jaar',
  validation: undefined
};
export default DateSelect;